import { FIND_DUPLICATES } from '../FindDuplicates';
import { ApiGateWay } from '../../../ApiGateWay/ApiGateWay';
import { Config } from '../../../config/config';
import Cookie from 'js-cookie';

const config = JSON.parse(Config);

export const RETAIL_INCIDENTS = async (url, userId, month, year) => {
  const fetchedData = await ApiGateWay.Post(config['api'] + url, {
    userId: userId,
    month: month,
    year: year,
  })
    .then((response) => response.json())
    .then((response) => {
      if (
        response.errorMessage === 'Token Expired' ||
        response.errorMessage === 'Invalid Token:::JWT expired' ||
        response.errorMessage ===
          'Your session has expired. Please login again.'
      ) {
        Cookie.remove('currentUser');
        Cookie.remove('stores');
        Cookie.remove('storesAll');
        Cookie.remove('warehouses');

        localStorage.clear();
        sessionStorage.clear();
        alert('Your session has expired. Please login again.');
        return (window.location = '/');
      }
      let body = [];
      let stores = [];
      let storeID = [];
      let colorCodes = [];
      let noOfIncidents = [];
      let imc = [];
      let closurePercentage = [];
      let NoOfIncidentData = [];
      let NoOfIncidentReports = [];
      let proxyjson = [];
      let IncidentsOfMandatoryClosureReportsData = [];
      let PendingApprovals = [];
      let MandatoryIncidentsClosedData = [];
      let PendApp = [];
      let insdentIn = [];
      response.globalIncidentReports
        .sort((a, b) => (a.storeName > b.storeName ? 1 : -1))
        .map((name, val) => {
          IncidentsOfMandatoryClosureReportsData = [];
          MandatoryIncidentsClosedData = [];
          body.push([
            name.incidentsCount,
            name.clousureIncidentsCount,
            name.incidentsPendingCount,
            name.incidentsClosedCount,
            name.closePercentage,
          ]);
          stores.push(name.storeName);
          storeID.push(name.storeId);
          noOfIncidents.push(name.incidentsCount);
          PendApp.push(name.incidentsPendingCount);
          imc.push(name.clousureIncidentsCount);
          closurePercentage.push(name.closePercentage);
          IncidentsOfMandatoryClosureReportsData = [];
          MandatoryIncidentsClosedData = [];
          PendingApprovals = [];
          NoOfIncidentData = [];

          name.storeIncidentInfos.map((info, index) => {
            NoOfIncidentData.push([
              info.incidentType + '-' + info.incidentStoreSerialNo,
              info.alertLevel,
              info.incidentStatus,
              info.incidentDate,
              info.incidentCreatedBy,
            ]);
            insdentIn.push(info);
            if (info.incidentType !== 'Theft') {
              IncidentsOfMandatoryClosureReportsData.push([
                info.incidentType + '-' + info.incidentStoreSerialNo,
                info.alertLevel,
                info.incidentStatus,
                info.incidentDate,
                info.incidentCreatedBy,
              ]);
            }
            if (info.incidentStatus == 'Pending Approval') {
              PendingApprovals.push([
                info.incidentType + '-' + info.incidentStoreSerialNo,
                info.alertLevel,
                info.incidentStatus,
                info.incidentDate,
                info.incidentCreatedBy,
              ]);
            }
            if (
              info.incidentType !== 'Theft' &&
              info.incidentStatus == 'Close'
            ) {
              MandatoryIncidentsClosedData.push([
                info.incidentType + '-' + info.incidentStoreSerialNo,
                info.alertLevel,
                info.incidentStatus,
                info.incidentDate,
                info.incidentCreatedBy,
              ]);
            }
          });
          NoOfIncidentReports.push([
            NoOfIncidentData,
            IncidentsOfMandatoryClosureReportsData,
            PendingApprovals,
            MandatoryIncidentsClosedData,
          ]);
          name.closePercentage === '100%'
            ? colorCodes.push([0, 1, 1, 1, 1])
            : colorCodes.push([0, 2, 2, 2, 2]);
        });

      return (proxyjson = {
        type: 'Incidents',
        storeId: storeID,
        thead: [
          'Store Name',
          'No of Incidents',
          'Incidents of Mandatory Closure',
          'Pendng Approvals',
          'Mandatory Incidents Closed',
          'Closure Status',
        ],
        tbody: body,
        columns: [
          'incidentsCount',
          'clousureIncidentsCount',
          'incidentsPendingCount',
          'incidentsClosedCount',
          'closePercentage',
        ],
        stores: stores,
        colorCodes: colorCodes,
        popUpDataGrid: NoOfIncidentReports,
        popUpDataGridHeaders: [
          'Incident Type',
          'Alert Level',
          'Status',
          'Date',
          'Created By',
        ],
        noOfIncidents: noOfIncidents,
        incidentsMC: imc,
        pendingApprovals: PendApp,
        incidentInfos: insdentIn,
        closure: closurePercentage,
      });
    });
  return fetchedData;
};
